import { render, staticRenderFns } from "./page-layout.vue?vue&type=template&id=221c8ae8&scoped=true"
import script from "./page-layout.vue?vue&type=script&lang=js"
export * from "./page-layout.vue?vue&type=script&lang=js"
import style0 from "./page-layout.vue?vue&type=style&index=0&id=221c8ae8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221c8ae8",
  null
  
)

export default component.exports